import React from 'react';

import {Badge} from '../../../components/Badge';
import {
  MediaLibraryItemStatus,
  TMediaLibraryItem,
} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';

interface IProps {
  media: TMediaLibraryItem;
  size?: React.ComponentProps<typeof Badge>['size'];
}

export const MediaChip: React.FC<IProps> = (props) => {
  return (
    <Badge
      label={getLabel(props.media)}
      backgroundColor={getCompStatusColor(props.media)}
      color="#fff"
      size={props.size}
    />
  );
};

export const getCompStatusColor = (media: TMediaLibraryItem) => {
  if (media.status === MediaLibraryItemStatus.PENDING) {
    return '#ffc800';
  } else if (media.status === MediaLibraryItemStatus.ERROR) {
    return '#cc0000';
  } else {
    return '#63b700';
  }
};

const getLabel = (media: TMediaLibraryItem) => {
  if (media.status === MediaLibraryItemStatus.PENDING) {
    return 'PROCESSING';
  } else if (media.status === MediaLibraryItemStatus.ERROR) {
    return 'ERROR';
  } else {
    return 'READY';
  }
};
